module.exports = __webpack_public_path__ + "4e8a31153f5542dd1effe49844504d27.pdf";